<template>
  <div class="nutrient-removal">
    <AppContainer size="lg">
      <section class="nutrient-removal__crops">
        <AppHeading element="h3" size="sm" spacing="lg" theme="black">
          Select Your Crop
        </AppHeading>
        <CropList v-model="selectedCrop" class="nutrient-removal__crop-list" :crops="cropNames" />
      </section>

      <div class="nutrient-removal__row">
        <section class="nutrient-removal__yield">
          <AppHeading element="h3" size="sm" spacing="xs" theme="black" class="adjust-heading">
            Adjust Your Yield
          </AppHeading>
          <AppParagraph class="selected-crop"> Selected Crop: {{ selectedCrop }} </AppParagraph>
          <NutrientRemovalYield :crop="selectedCropData" @change="handleYieldChange" />
        </section>

        <section class="nutrient-removal__graph">
          <AppHeading element="h3" size="sm" spacing="xs" theme="black" class="removal-chart">
            See Your Nutrient Removal Rate&#42;
          </AppHeading>
          <NutrientRemovalGraph :crop="selectedCropData" :yieldPercentage="selectedCropYield.percentage" />
        </section>
      </div>
    </AppContainer>
  </div>
</template>

<script>
import { OrganizationSchema } from '@/content/schema';
import cropData from '@/content/nutrient-removal';

import AppContainer from '@/components/shared/AppContainer';
import AppHeading from '@/components/shared/AppHeading';
import AppParagraph from '@/components/shared/AppParagraph';
import AppSubheading from '@/components/shared/AppSubheading';
import CropList from '@/components/shared/CropList';
import NutrientRemovalGraph from '@/components/NutrientRemovalGraph';
import NutrientRemovalYield from '@/components/NutrientRemovalYield';

export default {
  components: {
    AppContainer,
    AppHeading,
    AppSubheading,
    AppParagraph,
    CropList,
    NutrientRemovalGraph,
    NutrientRemovalYield
  },
  data() {
    return {
      cropData,
      selectedCrop: cropData[0].name,
      selectedCropYield: {}
    };
  },
  computed: {
    cropNames() {
      return this.cropData.map(c => c.name);
    },
    selectedCropData() {
      return this.cropData.find(c => c.name === this.selectedCrop);
    },
    selectedYieldValue() {
      if (this.selectedCropYield.value) {
        return `${this.selectedCropYield.value} (BU/AC)`;
      }
      return '';
    }
  },
  methods: {
    handleYieldChange(cropYield) {
      this.selectedCropYield = cropYield;
    }
  },
  jsonld() {
    return OrganizationSchema();
  }
};
</script>

<style lang="scss" scoped>
.nutrient-removal {
  &__heading {
    margin: spacing('xl', 2) 0;
    text-align: center;
  }

  &__crops {
    &:deep(.heading){
      font-family: $inter;
      font-size: 28px;
      font-weight: 700;
      line-height: 30px;
      text-align: left;
      text-transform: none;
    }

    border-bottom: solid 2px shade('white', 10%);
    border-top: solid 2px shade('white', 10%);
    margin: spacing('xl', 2) 0;
    padding: spacing('xl') 0;
    text-align: center;
  }

  &__row {
    @include breakpoint('md') {
      display: flex;
    }
  }

  &__yield {
    border-bottom: solid 2px shade('white', 10%);
    margin-bottom: spacing('xl');
    padding-bottom: spacing('xl');

    @include breakpoint('md') {
      border-bottom: 0;
      margin-bottom: 0;
      padding-right: spacing('xl', 2);
    }
    .adjust-heading {
      font-size: 28px;
      font-family: $articulat-cf;
      font-weight: 800;
      line-height: 32px;
      text-align: left;
      text-transform: none;
    }
    .selected-crop {
      color: color('hearty-green');
      font-size: 16px;
      font-family: $inter;
      font-weight: 400;
      line-height: 22px;
      text-align: left;
      text-transform: none;
    }
  }

  &__graph {
    .removal-chart {
      font-size: 24px;
      font-family: $articulat-cf;
      font-weight: 800;
      line-height: 28px;
      text-transform: none;

      @include breakpoint('md') {
        font-size: 28px;
        font-weight: 800;
        line-height: 32px;
        text-transform: none;
      }
    }

    @include breakpoint('md') {
      width: 100%;
    }
  }
}
</style>
